module.exports = __webpack_public_path__ + "img/dori_Immun_5.880f0a23.jpg";